module.exports = __webpack_public_path__ + "static/media/top2.0b2e2f5a.webp";